// Utility to get the current commit hash
// This will be populated during the build process by Vite

// Try to get commit hash from environment variable (set during build)
const getCommitHash = () => {
  // Check for environment variable first (set during build)
  if (process.env.REACT_APP_COMMIT_HASH) {
    return process.env.REACT_APP_COMMIT_HASH;
  }
  
  // Fallback to a placeholder if not available
  return 'development';
};

// Get a shortened version of the commit hash for display
const getShortCommitHash = () => {
  const hash = getCommitHash();
  if (hash === 'development') {
    return hash;
  }
  // Return first 7 characters of the hash (standard short hash length)
  return hash.substring(0, 7);
};

export { getCommitHash, getShortCommitHash }; 